import { render } from "./AddItemModal.vue?vue&type=template&id=5319c4ce&scoped=true"
import script from "./AddItemModal.vue?vue&type=script&lang=js"
export * from "./AddItemModal.vue?vue&type=script&lang=js"

import "./AddItemModal.vue?vue&type=style&index=0&id=5319c4ce&scoped=true&lang=scss"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5319c4ce"]])

export default __exports__